import { z } from "zod";

export const create = z.object({
  name: z.string().min(1, "Required"),
  code: z.string().min(1, "Required"),
  type: z.enum(["MEDIA", "REAGENT", "AGAR", "OTHER"]),
  lotLabel: z.string().optional(),
});

export const update = create.extend({ id: z.number() });
